import { FC, useEffect } from "react"
import { useDispatch } from "react-redux"
import UserContentInfo from "./UserContentInfo"
import UserPreview from "./UserPreview"
import DualPanelModal from "@/components/DualPanelModal"
import UserForm from "@/components/UserModal/UserForm"
import { TestId } from "@/constants/globals"
import { UserFormData } from "@/pages/Settings/Users/types"
import { AppDispatch } from "@/store"
import { resetCreateUserState as resetCreateUserStateAction } from "@/store/usersSlice"
import { ColorVariant } from "@/types/index"
import "./index.scss"

interface UsersModalProps {
   openModal: boolean
   errorCreateUser: number | null
   handleCloseModal: () => void
   savedUser: UserFormData | null
   handleSaveUser: (data: UserFormData) => void
   variant: ColorVariant
   facilityName?: string
}

const UserModal: FC<UsersModalProps> = ({
   openModal,
   errorCreateUser,
   handleCloseModal,
   savedUser,
   handleSaveUser,
   variant,
   facilityName,
}) => {
   const isPreviewMode = !!savedUser
   const dispatch = useDispatch<AppDispatch>()

   useEffect(() => {
      return () => {
         dispatch(resetCreateUserStateAction())
      }
   }, [dispatch])

   const handleResetForm = () => {
      handleCloseModal()
   }

   return (
      <DualPanelModal
         open={openModal}
         centered
         variant={variant}
         onClose={handleCloseModal}
         infoSection={
            <UserContentInfo
               variant={variant}
               iconName="guardUser"
               iconSize="27"
               headerText={isPreviewMode ? "User invited" : "Invite a user"}
               {...(isPreviewMode && {
                  headerTestId: TestId.USER_FORM_SUCCESS_HEADER,
               })}
               contentText={
                  isPreviewMode
                     ? "An email invitation has been sent to the new user to join the facility:"
                     : "Complete all fields and save to send an email invitation to the new user to join facility:"
               }
               facilityName={facilityName}
            />
         }
         actionSection={
            isPreviewMode ? (
               <UserPreview
                  user={savedUser}
                  onDismiss={handleResetForm}
               />
            ) : (
               <UserForm
                  submitError={errorCreateUser}
                  onSave={handleSaveUser}
               />
            )
         }
      />
   )
}

export default UserModal
